import React from 'react';
import { ComponentType } from '../../utils/events/types';
import { CollectionsContextProvider } from '../internal/context/CollectionsContext';
import { MixpanelContextProvider } from '../internal/context/events/MixpanelContext';
import { BigQuery } from '../internal/BigQuery';
import { BigQueryImpressionContainer } from '../internal/BigQueryImpressionContainer';
import type { InspireCarouselProps } from './types';
import { Carousel, CarouselSkeleton } from './Carousel';
import { DEFAULT_TITLE, DEFAULT_IS_LOADING } from './constants';

export const InspireCarousel = ({
  inspireDeliveries,
  title = DEFAULT_TITLE,
  isLoading = DEFAULT_IS_LOADING,
  onSeenAll,
  onShowMore,
  onCardHrefClick,
  onCardImpression,
  mixpanelEnabled,
  mixpanelOptions,
  bigQueryEnabled,
  bigQueryOptions,
  cardHrefRouteOptions,
  ...collectionsData
}: InspireCarouselProps) => (
  <MixpanelContextProvider
    componentType={ComponentType.Carousel}
    mixpanelEnabled={mixpanelEnabled}
    mixpanelOptions={mixpanelOptions}
    inspireDeliveries={inspireDeliveries}
  >
    <BigQuery variant="carousel" bigQueryEnabled={bigQueryEnabled} bigQueryOptions={bigQueryOptions}>
      <CollectionsContextProvider {...collectionsData}>
        {title ? <h4 className="m-b-24">{title}</h4> : null}
        {isLoading ? (
          <CarouselSkeleton />
        ) : (
          <BigQueryImpressionContainer intersectionThreshold={1}>
            <Carousel
              inspireDeliveries={inspireDeliveries}
              onSeenAll={onSeenAll}
              onShowMore={onShowMore}
              onCardHrefClick={onCardHrefClick}
              onCardImpression={onCardImpression}
              cardHrefRouteOptions={cardHrefRouteOptions}
            />
          </BigQueryImpressionContainer>
        )}
      </CollectionsContextProvider>
    </BigQuery>
  </MixpanelContextProvider>
);
